import { useCallback } from 'react';

import { useHistory } from 'src/lib/hooks/useHistory';
import { captureMessage } from 'src/lib/sentry';
import { ROUTES } from 'src/routes';
import { useCustomerActions } from 'src/store';

export const useSelectCurrentCustomer = () => {
  const history = useHistory();
  const customerStoreActions = useCustomerActions();

  const handleSelectCustomer = useCallback(
    async (customerId) => {
      // The selected account decides between the reviewer app and the full app. Leave the page
      // before the switch: on a project page, the other app's project link gate would otherwise
      // switch back to the project's account.
      history.push(ROUTES.ROOT);

      try {
        await customerStoreActions.selectCurrentCustomer(customerId);

        return true;
      } catch (error) {
        captureMessage("Couldn't select customer", {
          level: 'warning',
          extra: {
            error: error.toString(),
            source: 'useSelectCurrentCustomer',
          },
        });
      }

      return false;
    },
    [customerStoreActions, history]
  );

  return {
    handleSelectCustomer,
  };
};
